/**
 * created by: llh
 * 一键快撤-撤稿详情
 */
angular.module('manageSysOneKeyWithdrawDetailModule', [])
    .controller('manageSysOneKeyWithdrawDetailCtrl', ['$scope', 'trsHttpService', '$q', '$stateParams', '$state', 'modalDialog', 'localStorageService', 'trsspliceString',
        function($scope, trsHttpService, $q, $stateParams, $state, modalDialog, localStorageService, trsspliceString) {
            initStatus();
            initData();

            function initStatus() {
                $scope.status = {
                    keywords: '',
                };

                $scope.data = {
                    items: [],
                    selectedArray: [],
                    item: '',
                };
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                    PAGECOUNT: 0,
                    ITEMCOUNT: 0,
                    copyCurrPage: 1,
                };
            }

            function initData() {
            	// $scope.data.items = $scope.fake.DATA;
                // $scope.page.ITEMCOUNT = $scope.fake.PAGER.ITEMCOUNT;
                // $scope.page.PAGECOUNT = $scope.fake.PAGER.PAGECOUNT;
                // $scope.data.item = JSON.parse(localStorageService.get('oneKeyWithdrawLogItem'));
                getDetailList();
            }
            /**
             * [getDetailList description] 获取详细日志列表
             */
            function getDetailList(){
                let docIds = '';
                $scope.data.item = JSON.parse(localStorageService.get('oneKeyWithdrawLogItem'));
                let searchParams = $scope.data.item.SEARCHPARAMS;
                if($scope.data.fromdate && $scope.data.untildate){
                    let timeString = $scope.data.fromdate + ' 00:00:00,' + $scope.data.untildate + ' 23:23:59';
                    getSearchField('timeType',searchParams).keywords = timeString;
                }
                if($scope.status.keywords){
                    let keyString;
                    if(getSearchField('keywordsOr',searchParams).keywords)
                        keyString = getSearchField('keywordsOr',searchParams).keywords + $scope.status.keywords;
                    else
                        keyString = $scope.status.keywords;
                    getSearchField('keywordsOr', searchParams).keywords = keyString;
                }
                var detailParams = {
                    serviceid: 'mlf_withdrawdoc',
                    methodname: 'querywithdrawLogDoc',
                    mediaType: $scope.data.item.MEDIATYPE ? $scope.data.item.MEDIATYPE : 1,
                    logId: $scope.data.item.WITHDRAWALLOGID,
                    searchparams: {
                        'PAGESIZE': $scope.page.PAGESIZE,
                        'PAGEINDEX': $scope.page.CURRPAGE,
                        'searchFields': searchParams,
                    }
                }
                detailParams.searchparams = JSON.stringify(detailParams.searchparams);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),detailParams,'post').then(function(data){
                    $scope.data.items = data.DATA;
                    $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                    $scope.page.PAGESIZE = data.PAGER.PAGESIZE;
                    docIds = trsspliceString.spliceString($scope.data.items,'CHNLDOCID',',');
                    if(docIds!=''){
                        var statusParams = {
                            serviceid: 'mlf_withdrawdoc',
                            methodname: 'queryWithdrawDocStatus',
                            chnlDocIds: docIds
                        }
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),statusParams,'post').then(function(data){
                            for(var i in $scope.data.items){
                                $scope.data.items[i]['STATUS'] = data[$scope.data.items[i]['CHNLDOCID']] ? '撤稿成功' : '撤稿失败';
                            }
                        });
                    }
                });
            }
            $scope.search = function(){
                getDetailList();
            }
            /**
             * [selectPageNum description] 选择一页要显示的数据量
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function() {
                $scope.page.copyCurrPage = 1;
                getDetailList();
            };
            /**
             * [pageChanged description] 下一页 页面改变调取数据
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.page.copyCurrPage = $scope.page.CURRPAGE;
                getDetailList();
            };
            /**
             * [jumpToPage description] 跳转页
             * @return {[type]} [description]
             */
            $scope.jumpToPage = function() {
                if ($scope.page.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.page.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.page.copyCurrPage;
                getDetailList();
            };
            function getSearchField(fieldString, arr){
                var obj = arr.find(item =>item.searchField === fieldString);
                return obj;
            }
        }
    ]);